import {default as ErrorHandler, DEFAULT_GENERAL_ERROR_CODE} from './error_handler';

// Error Handlers
export {ErrorHandler};
export {default as ClientErrorHandler} from './external_error_handler';

// Errors
export {default as CLIENT_ERRORS} from './errors/client_errors';
export const DEFAULT_ERROR = {code: DEFAULT_GENERAL_ERROR_CODE}; // the rest gets automatically updated on throw



// WEBPACK FOOTER //
// ./src/modules/error_handler/index.js